import { render, staticRenderFns } from "./AlliancesModuleComponent.vue?vue&type=template&id=0fc46de4&scoped=true"
import script from "./AlliancesModuleComponent.vue?vue&type=script&lang=js"
export * from "./AlliancesModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./AlliancesModuleComponent.vue?vue&type=style&index=0&id=0fc46de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc46de4",
  null
  
)

export default component.exports